'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _confirmRegistration = require('./confirmRegistration.html');

var _confirmRegistration2 = _interopRequireDefault(_confirmRegistration);

var _confirmRegistration3 = require('./confirmRegistration.controller');

var _confirmRegistration4 = _interopRequireDefault(_confirmRegistration3);

require('./confirmRegistration.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var confirmRegistrationComponent = {
  bindings: {},
  template: _confirmRegistration2.default,
  controller: _confirmRegistration4.default,
  controllerAs: "vm"
};

exports.default = confirmRegistrationComponent;


// WEBPACK FOOTER //
// ./client/app/components/confirmRegistration/confirmRegistration.component.js